import "./callbackform.scss";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InputMask from "react-input-mask";

const CallbackSchema = Yup.object().shape({
    username: Yup.string()
        .min(2, "Your name is too short")
        .max(12, "Your name is too long")
        .required("Name is required"),
    email: Yup.string()
        .email("Email not valid!")
        .required("Email is required"),
    phone: Yup.string(),
    message: Yup.string()
        .min(5, "Your message too short")
        .max(50, "Your message too long, cut it little bit")
});


function CallbackForm() {
    const [isValid, setIsValid] = useState(false);

    function succesfulSubmit() {
        setIsValid(!isValid);
    }

    return (
        <div>
            {isValid ? (
                <div className="form-success">
                    <div className="success-icon">
                        <CheckCircleIcon />
                    </div>
                    <div className="success-title">
                        Thank you for your message!
                        I will reply soon!
                    </div>
                </div>
            ) : (
                <Formik
                    initialValues={
                        {
                            username: "",
                            email: "",
                            phone: "",
                            message: ""
                        }
                    }
                    onSubmit={() => {
                        succesfulSubmit();
                    }}
                    validationSchema={CallbackSchema}
                >
                    {({ values, errors, touched }) => (
                        <Form className="form">
                            <h2 className="callback-form-title">
                                Call me back
                            </h2>
                            <div className="form-group">
                                {errors.username && touched.username ? (
                                    <label className="label-error">{errors.username}</label>
                                ) : (
                                    <label htmlFor="username" className="label">
                                        Name
                                    </label>
                                )}
                                <Field placeholder="Your name"
                                    name="username"
                                    type="input"
                                    id="username"
                                    className="input"
                                />
                            </div>
                            <div className="form-group">
                                {errors.email && touched.email ? (
                                    <label htmlFor="email" className="label-error">{errors.email}</label>
                                ) : (
                                    <label htmlFor="email" className="label">
                                        Email
                                    </label>
                                )}
                                <Field placeholder="Your email"
                                    name="email"
                                    type="input"
                                    id="email"
                                    className="input"
                                />
                            </div>
                            <div className="form-group">
                                {errors.phone && touched.phone ? (
                                    <label htmlFor="phone" className="label-error">{errors.phone}</label>
                                ) : (
                                    <label htmlFor="phone" className="label">
                                        Phone
                                    </label>
                                )}
                                <InputMask placeholder="Your phone"
                                    name="phone"
                                    type="input"
                                    id="phone"
                                    className="input"
                                    mask="+9 (999) 999-99-99"
                                    maskChar={null}
                                />
                            </div>
                            <div className="form-group">
                                {errors.message && touched.message ? (
                                    <label htmlFor="message" className="label-error">{errors.message}</label>
                                ) : (
                                    <label htmlFor="message" className="label">
                                        Message
                                    </label>
                                )}
                                <Field placeholder="Your message"
                                    name="message"
                                    type="input"
                                    id="message"
                                    className="input"
                                />
                            </div>
                            <div className="form-group">
                                <input className="form-submit" type="submit" value="Send" />
                            </div>
                        </Form>
                    )}
                </Formik >
            )}
        </div >
    )
}

export default CallbackForm